<template>
  <div class="video">
    <Left :detailsData="detailsData"></Left>
    <VideoComponents
      @getDetails="getDetails"
      :detailsData="detailsData"
    ></VideoComponents>
    <Right
      :periodicalInfo="periodicalInfo"
      :periodicalId="periodicalId"
      :detailsData="detailsData"
      :timeData="timeData"
      :autherInfo="autherInfo"
    ></Right>
  </div>
</template>

<script>
import Left from "../components/left";
import VideoComponents from "./components/videoComponents";
import Right from "./components/right";

export default {
  components: {
    Left,
    VideoComponents,
    Right,
  },
  data() {
    return {
      detailsData: {},
      wenxian: [],
      autherInfo: {},
      // autherList: {},
      timeData: {},
      periodicalId: {},
      periodicalInfo: {},
    };
  },
  watch: {
    $route: {
      handler() {
        this.getDetails();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getAuthor() {
      let obj = {
        type: this.detailsData.data.userType,
        userId: this.detailsData.data.createUser,
      };
      console.log(obj, "getAuthorPublisherObj");
      const res = await this.$apis.recomendServe.getAuthor(obj);
      console.log(res);
      this.autherInfo = res.content;
      console.log(this.autherInfo, "this.autherInfo");
    },
    async Getperiodical() {
      let obj = {
        id: this.detailsData.data.periodicalId,
      };
      console.log(obj, "GetperiodicalObj");
      const res = await this.$apis.recomendServe.periodical(obj);
      this.periodicalInfo = res.content.periodicalInfo;
    },
    async getperiodiID() {
      let obj = {
        periodicalId: this.detailsData.data.periodicalId,
      };
      console.log(obj, "getperiodiIDObj");
      const res = await this.$apis.recomendServe.periodiID(obj);
      this.periodiID = res.data;
      console.log(res);
    },
    async getDetails() {
      console.log("GetDetailsData");
      let arr = {};
      if (sessionStorage.getItem("Table")) {
        arr = JSON.parse(sessionStorage.getItem("Table")).PlatformEnum;
      } else {
        await this.getTable();
        arr = JSON.parse(sessionStorage.getItem("Table")).PlatformEnum;
      }
      let PlatformEnumObj = {};
      arr.forEach((item) => {
        if (item.name === "中文知识网") {
          PlatformEnumObj = item;
        }
      });
      const obj = {
        pid: PlatformEnumObj.id,
        videoId: this.$router.history.current.query.id,
      };
      console.log(obj);
      const data = await this.$apis.recomendServe.videoDetails(obj);
      this.detailsData = data;
      document.title = this.detailsData.data.title;
      console.log(this.detailsData);
      if (this.detailsData.data.userType === 1) {
        await this.Getperiodical();
        await this.getperiodiID();
      } else {
        await this.getAuthor();
      }
      console.log(this.detailsData);
    },
  },
};
</script>

<style lang="scss" scoped>
.video {
  width: 1300px;
  display: flex;
}
</style>
